import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LightingUpAngularModule } from 'lighting-up-angular';
import { EnteteMobileComponent } from './entete-mobile.component';;
import { MenuCompteUtilisateurModule } from '../menu-compte-utilisateur/menu-compte-utilisateur.module';

@NgModule({
	declarations: [EnteteMobileComponent],
	imports: [CommonModule, LightingUpAngularModule, MenuCompteUtilisateurModule],
	exports: [EnteteMobileComponent]
})
export class EnteteMobileModule { }
